import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	Input,
	Output,
	ViewEncapsulation,
} from "@angular/core";
import { DgaRegistrationFormGroup } from "@obg/common.registration";

@Component({
	selector: "obg-m-cpr-number-field",
	templateUrl: "./cpr-number-field.component.html",
	styleUrls: ["./cpr-number-field.component.scss"],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CprNumberFieldComponent {
	@HostBinding("class.obg-m-cpr-number-field") hostCssClass = true;

	@Input() formGroup: DgaRegistrationFormGroup | undefined;
	@Input() appearance: string | undefined;
	@Input() inlineTips = false;
	@Input() fieldValue = "";
	@Input() required = true;
	@Input() tooltipDisabled = false;
	@Input() translationPrefix = "register.cprnumber";

	@Output() fieldChange = new EventEmitter<string>();
	@Output() focused: EventEmitter<boolean> = new EventEmitter<boolean>();
}
